<template>
  <div class="manage-panel-location-container manage-panel-inner-container">
    <div class="control">
      <el-input
        size="small"
        v-model="listQuery.name"
      >
        <template #suffix>
          <svg-icon :iconName="listQuery.loading?'loading':'el-Search'"
            @click="searchFn"
          ></svg-icon>
        </template>
      </el-input>
    </div>
    <el-scrollbar class="manage-panel-location-scrollbar inner-scrollbar">
      <div class="item-entity"
        v-for="(item, index) of tableList"
        :key="index"
        @click="entityClick(item)"
        :class="{
          'item-entity-hover': item[clickCheckProp],
        }"
      >
        <div class="title ellipsis" >
          {{ item['name'] }}
        </div>
        <div class="title ellipsis" >
          意图：{{ item['purpose'] }}
        </div>
        <div class="title ellipsis" >
          创建时间：{{ item['createTime'] }}
        </div>
      </div>
    </el-scrollbar>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.length"
        layouts="total, pager,"
      />
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, 
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message } from '@/utils/js/initVariable';

import Pagination from '@/components/Pagination';

import { queryFavoriteDetail, } from'@/api/UserDrawApi';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);
const homeMap = computed(() => store.getters.getHomeMap),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupClear = ()=>{
        layerGroup.clearLayers();
      }

const layerInit = (item)=>{
  if(!item['geom'])return;
  const geojson = L.geoJSON(JSON.parse(item['geom']));
  item[layerProp] = geojson;
  return geojson;
}

const clickCheckProp = ref('clickCheck'), layerProp = 'layer';
const entityClick = (item)=>{
  const layer = item[layerProp] || layerInit(item);
  item[clickCheckProp.value] = !item[clickCheckProp.value];
  if(item[clickCheckProp.value]){
    layer && layerGroup.addLayer(layer);
    map.fitBounds(layer.getBounds(), {
      maxZoom: 6,
    });
  }else{
    layer && layerGroup.removeLayer(layer);
  }
}

const searchFn = ()=>{
  selectList();
}

const tableList = ref([])
const total = ref(0),
    listQuery = reactive({
      page: 1,
      length: 20,
      name: '',
      loading: false,
    })
// 分页器change
const pageChange = ()=>{
  selectList()
}

const selectList = ()=>{
  listQuery.loading = true;
  queryFavoriteDetail(listQuery).then(res=>{
    if(res.data.code == 1004){
      layerGroupClear();
      tableList.value = res.data.dataList;
      total.value = res.data.totalCount || 0;
    }
  }).catch(err=>{
    console.log(err);
  }).finally(()=>{
    listQuery.loading = false;
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  selectList();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.manage-panel-location-container{
  .control{
    :deep(.el-input){
      .el-input__suffix{
        i{
          cursor: pointer;
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}
</style>